export default __webpack_public_path__ + "static/media/2023_Ke_and_Wan_2023_PlantSoil.8c7950ab.pdf";